import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';

import type { BankAccount } from './types';

type Variables = {
  amount1Cents: number;
  amount2Cents: number;
};

type Response = BankAccount;

export const useVerifyBankAccount = createMutation<
  Response,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: 'v2/internal/partners/bank_accounts/verify',
      method: 'POST',
      data: {
        amount_1_cents: variables.amount1Cents,
        amount_2_cents: variables.amount2Cents,
      },
    })
      .then((response) => response.data.data)
      .catch((err: any) => {
        const errors = err.response?.data?.errors;
        throw new Error(
          Array.isArray(errors)
            ? errors.join(', ')
            : 'The amounts you entered did not match. Please try again.'
        );
      }),
});
